/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:35:02
 * @LastEditTime: 2023-09-06 11:06:44
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\behavior-statistics-report\modules\dataAnalyseRouter.js
 * 数据分析
 */
import store from '@/store'
import { getReportSetting } from '@/api/behaviorManage'
const dataAnalyseRouter = [
  // 行为管理 数据分析 - 报表中心
  {
    path: '/behaviorManage/report-forms',
    name: 'behaviorManageReportForms',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage4" */
      //   '@/views/behaviorManage/dataAnalysis/ReportForms.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage4" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/report-center/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '报表中心'
    }
  },
  // 行为管理 数据分析 - 报表中心 详情列表
  {
    path: '/behaviorManage/report-forms-details-list/:meta_type',
    name: 'behaviorManageReportFormsDetailsList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage4" */
      //   '@/views/behaviorManage/dataAnalysis/ReportFormsDetailsList.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage4" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/report-center/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      isMoreMeta: true,
      1: {
        title: '岗位拜访统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      2: {
        title: '岗位协访统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      3: {
        title: '部门拜访统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      4: {
        title: '部门协访统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      5: {
        title: '档案受访统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      6: {
        title: '院内院外拜访统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      7: {
        title: '任务评分统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      8: {
        title: '任务关注统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      9: {
        title: '活动形式统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      10: {
        title: '岗位活动统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      },
      11: {
        title: '部门活动统计',
        breadcrumb: [
          {
            title: '报表中心',
            name: 'behaviorManageReportForms'
          }
        ]
      }
    }
  },
  // 行为管理 数据分析 - 工作统计
  {
    path: '/behaviorManage/work-statistics',
    name: 'behaviorManageWorkStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage5" */
      //   '@/views/behaviorManage/dataAnalysis/WorkStatistics.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage5" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/WorkStatistic.vue'
      ),
    async beforeEnter(to, from, next) {
      // 工作统计配置
      getReportSetting(27).then((res) => {
        if (res.status == 0) {
          let work_config = res.data
          store.commit('set_work_config', work_config)
          next()
        }
      })
    },
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '工作统计'
    }
  },
  // 行为管理 数据分析 - 投入资源统计
  {
    path: '/behaviorManage/input-resource-statistics',
    name: 'behaviorManageInputResourceStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageInputResourceStatistics" */
      //   '@/views/behaviorManage/dataAnalysis/InputResourceStatistics.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageInputResourceStatistics" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/input-resources/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '投入资源统计'
    }
  },

  // 行为管理 数据分析 - 投入资源统计详情
  {
    path: '/behaviorManage/input-resource-detail/:meta_type/:id/:json',
    name: 'behaviorManageInputResourceDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageInputResourceDetail" */
      //   '@/views/behaviorManage/dataAnalysis/InputResourceDetail.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageInputResourceDetail" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/input-resources/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      isMoreMeta: true,
      1: {
        title: '岗位投入资源详情',
        breadcrumb: [
          {
            title: '投入资源统计',
            name: 'behaviorManageInputResourceStatistics'
          }
        ]
      },
      2: {
        title: '医生投入资源详情',
        breadcrumb: [
          {
            title: '投入资源统计',
            name: 'behaviorManageInputResourceStatistics'
          }
        ]
      },
      3: {
        title: '医院投入资源详情',
        breadcrumb: [
          {
            title: '投入资源统计',
            name: 'behaviorManageInputResourceStatistics'
          }
        ]
      }
    }
  },
  // 行为管理 数据分析 - 报表 统计导出中心
  {
    path: '/behaviorManage/dataAnalysis-export',
    name: 'behaviorManageExportCenter',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage5" */
      //   '@/views/behaviorManage/dataAnalysis/ExportCenter.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManage5" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/StaticExportCenter.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '统计导出中心'
    }
  },
  // 行为管理 数据分析 -关键信息传达
  {
    path: '/behaviorManage/key-info',
    name: 'behaviorManageDoctorKeyInfoList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorVisitTemplateList" */
      //   '@/views/behaviorManage/key-info/List.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDoctorVisitTemplateList" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/KeyInforTrans.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '关键信息传达'
    }
  },
  // 行为管理 数据分析 -活动数据统计
  {
    path: '/behaviorManage/activity-data-statistics',
    name: 'behaviorManageDoctorActivityDataStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDoctorVisitTemplateList" */
      //   '@/views/behaviorManage/ActivityDataStatistics.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDoctorVisitTemplateList" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/ActivityDataStatic.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '活动数据统计'
    }
  },
  // 行为管理 数据分析 -勤奋榜
  {
    path: '/behaviorManage/diligence',
    name: 'behaviorManageDiligence',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDiligence" */
      //   '@/views/behaviorManage/diligence/List.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDiligence" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/diligence-list/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '勤奋榜'
    }
  },
  // 行为管理 数据分析 -勤奋榜 积分明细
  {
    path: '/behaviorManage/diligence/score-detail',
    name: 'behaviorManageDiligenceScoreDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageDiligence" */
      //   '@/views/behaviorManage/diligence/Detail'
      // ),
      import(
        /*webpackChunkName:"behaviorManageDiligence" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/diligence-list/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '积分明细',
      breadcrumb: [
        {
          title: '勤奋榜',
          name: 'behaviorManageDiligence'
        }
      ]
    }
  },
  // 工作地图
  {
    path: '/behaviorManage/work-map',
    name: 'behaviorManageWorkMap',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisiting" */
      //   '@/views/behaviorManage/work-map/List.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageVisiting" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/WorkMap.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '工作地图'
    }
  },
  // 人均拜访分析
  {
    path: '/behaviorManage/per-visit-analyse-page',
    name: 'behaviorManagePerVisitAnalysePage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePerVisitAnalysePage" */
      //   '@/views/behaviorManage/per-visit-analyse/Page'
      // ),
      import(
        /*webpackChunkName:"behaviorManagePerVisitAnalysePage" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/PerCapitavisit.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '人均拜访分析'
    }
  },
  // 代表KPI报表
  {
    path: '/behaviorManage/crm-statement-activity',
    name: 'behaviorManageCrmStatementActivity',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePhotoLibraryList" */
      //   '@/views/behaviorManage/crmStatementActivity/index.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManagePhotoLibraryList" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/behalf-kpi/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '代表KPI报表'
    }
  },
  // 代表KPI报表-明细
  {
    path: '/behaviorManage/crm-statement-activity/details/:quarter_id/:year/:month',
    name: 'behaviorManageCrmStatementActivityDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePhotoLibraryList" */
      //   '@/views/behaviorManage/crmStatementActivity/details.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManagePhotoLibraryList" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/behalf-kpi/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '代表KPI报表明细',
      breadcrumb: [
        {
          title: '代表KPI报表',
          name: 'behaviorManageCrmStatementActivity'
        }
      ]
    }
  },

  // 照片库列表
  {
    path: '/behaviorManage/photo-library-list',
    name: 'behaviorManagePhotoLibraryList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePhotoLibraryList" */
      //   '@/views/behaviorManage/photo-library/List.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManagePhotoLibraryList" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/photo-gallery/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '照片库'
    }
  },
  // 照片库详情
  {
    path: '/behaviorManage/photo-library-detail/:id/:type/:json',
    name: 'behaviorManagePhotoLibraryDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePhotoLibraryDetail" */
      //   '@/views/behaviorManage/photo-library/Detail.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManagePhotoLibraryDetail" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/photo-gallery/Detail.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '照片详情',
      breadcrumb: [
        {
          title: '照片库',
          name: 'behaviorManagePhotoLibraryList'
        }
      ]
    }
  },
  // 文件来源查询
  {
    path: '/behaviorManage/file-source',
    name: 'behaviorManageF',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePhotoLibraryList" */
      //   '@/views/behaviorManage/photo-library/List.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManagePhotoLibraryList" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/file-source/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '文件来源查询'
    }
  },

  // 综合拜访线路效率报告
  {
    path: '/behaviorManage/comprehensive-doctor-kpi',
    name: 'behaviorManageComprehensiveDoctorKpi',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageComprehensiveDoctorKpi" */
      //   '@/views/behaviorManage/ComprehensiveDoctorKpi.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManageComprehensiveDoctorKpi" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/VisitRouteEfficiency.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '综合拜访线路效率报告'
    }
  },
  // 讲者讲课次数
  {
    path: '/behaviorManage/behavior-statistics-report/data-analyse/speaker-count/page',
    name: 'behaviorManageSpeakerCount',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageComprehensiveDoctorKpi" */
        '@/views/behavior-manage/behavior-statistics-report/data-analyse/speaker-count/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据分析', //二级菜单
      title: '讲者讲课次数'
    }
  }
]
export default dataAnalyseRouter
